import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";

import { loadIsItmDataShownState } from "store/features/analysisResultsSlice";

// redux
import { useSelector, useDispatch } from "react-redux";

function ItmToggleComponent() {
    const dispatch = useDispatch();

    const isITMDataShown = useSelector((state) => state.analysisResultsStore.isItmDataShown);
    const isITMData = useSelector((state) => state.analysisResultsStore.isItmData);

    const handleITMToggleChange = () => {
        dispatch(loadIsItmDataShownState(!isITMDataShown));
    };

    return (
        <Button
            size="small"
            className={isITMData ? "custom-btn custom-btn-outlined-2 color-blue me-4 bold-content" : "custom-btn me-4 bold-content"}
            disabled={!isITMData}
            variant="outlined"
        >
            ITM
            <Switch
                size="small"
                disabled={!isITMData}
                checked={isITMDataShown}
                onChange={handleITMToggleChange}
            />
        </Button>
    );
}

export default ItmToggleComponent;
